// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"158":"labels","496":"campaigns","644":"account","721":"inbox","806":"user"}[chunkId] + "." + {"158":"0a304e5ee15af4f76b24","496":"08a35413f40535329a12","644":"f5939d03a3e609ffd0e6","721":"fbfded5c1a54c93dbc46","806":"edb7e99277d20434c449"}[chunkId] + ".js";
};